/* eslint-disable max-len */
import React from 'react'
import Setting from '../../containers/SettingContainer'
import MessengerCustomerChat from 'react-messenger-customer-chat'
import './Chat.scss'

class Chat extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      channels : [],
      botname : ''
    }
    let channel = window.localStorage.getItem('channel')
    if (channel === undefined || channel === null) {
      let possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      channel = ''

      for (var i = 0; i < 7; i++) {
        channel += possible.charAt(Math.floor(Math.random() * possible.length))
      }

      window.localStorage.setItem('channel', channel)
    }

    this.state.botname = channel
    this.state.channels.push({
      name: 'khách-hàng-vtt',
      id: { channel },
      icon: ''
    })
  }

  render () {
    return (
      <div className='header-chat'>
        <MessengerCustomerChat
          pageId={Setting.chatFBpageId}
          appId={Setting.chatFBappId}
          htmlRef={window.location.pathname}
        />
      </div>
    )
  }
}
export default Chat



// WEBPACK FOOTER //
// ./src/components/_partial/Chat.js